import BrandForm from './BrandForm';

export default BrandForm;
